<template>
  <div>
    <div v-if="!isAdmin() && !isConsultor()" class="mb-4">
      <Link class="group flex items-center py-3" href="/">
        <icon name="dashboard" class="mr-2 w-4 h-4" :class="isUrl('') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('') ? 'text-white' : 'text-indigo-500 group-hover:text-white'">Formulario</div>
      </Link>
    </div>
    <div v-if="isAdmin() || isConsultor()" class="mb-4">
      <Link class="group flex items-center py-3" href="/formularios">
        <icon name="dashboard" class="mr-2 w-4 h-4" :class="isUrl('formularios') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('formularios') ? 'text-white' : 'text-indigo-500 group-hover:text-white'">Listado de Formularios</div>
      </Link>
    </div>
    <div v-if="isAdmin() || isConsultor()" class="mb-4">
      <Link class="group flex items-center py-3" href="/oficinas">
        <icon name="office" class="mr-2 w-4 h-4" :class="isUrl('oficinas') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('oficinas') ? 'text-white' : 'text-indigo-500 group-hover:text-white'">Gestión de Oficinas</div>
      </Link>
    </div>
    <div v-if="isAdmin()" class="mb-4">
      <Link class="group flex items-center py-3" href="/usuarios">
        <icon name="users" class="mr-2 w-4 h-4" :class="isUrl('usuarios') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('usuarios') ? 'text-white' : 'text-indigo-500 group-hover:text-white'">Gestión de Usuarios</div>
      </Link>
    </div>
    <div v-if="isAdmin()" class="mb-4">
      <Link class="group flex items-center py-3" href="/datos">
        <icon name="printer" class="mr-2 w-4 h-4" :class="isUrl('datos') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('datos') ? 'text-white' : 'text-indigo-500 group-hover:text-white'">Precarga de datos</div>
      </Link>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'

export default {
  components: {
    Icon,
    Link,
  },
  props: {
    admin: Boolean,
    consultor: Boolean,
  },
  methods: {
    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter((url) => currentUrl.startsWith(url)).length
    },
    isAdmin() {
      return this.admin
    },
    isConsultor() {
      return this.consultor
    },
  },
}
</script>
